module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-0ba7f07ee22d6e4fff39fbb0bb7e3b5f.png";